<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" *ngIf="mode === 'create'">{{"MATHS_SUBSCRIPTION_CREATE" | translate}}</h4>
    <h4 class="modal-title" *ngIf="mode === 'update'">{{"MATHS_SUBSCRIPTION_UPDATE" | translate}}</h4>
    <h4 class="modal-title" *ngIf="mode === 'read'">{{"MATHS_SUBSCRIPTION_READ" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body formModal">
    <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
    <mat-horizontal-stepper [linear]="true" #stepper *ngIf="!readOnly">
      <mat-step [stepControl]="mathsNaiveForm">
        <form [formGroup]="mathsNaiveForm" *ngIf="mathsNaiveForm">
          <ng-template matStepLabel>{{'SUBSCRIPTION_DATES'|translate}}</ng-template>
          <mat-form-field>
            <input matInput formControlName="dateStart" [matDatepicker]="picker1"
                   placeholder="Start subscription date">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <input matInput formControlName="dateEnd" [matDatepicker]="picker2"
                   placeholder="End subscription date">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <div>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next</button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="mathsNaiveStaticForm">
        <form [formGroup]="mathsNaiveStaticForm" *ngIf="mathsNaiveStaticForm">
          <ng-template matStepLabel>{{'STATIC_SETTINGS'|translate}}</ng-template>
          <mat-slide-toggle formControlName="doStatic" [(ngModel)]="mathsNaiveStaticForm.value.doStatic">
            {{mathsNaiveStaticForm.value.doStatic
            ? 'Static enabled' : 'Static disabled'}}
          </mat-slide-toggle>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Statics settings (eacth v1.0)
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-form-field>
              <input matInput placeholder="windowSize (hours)" formControlName="window_Size" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="noteMAX" formControlName="noteMAX" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="coefLT" formControlName="coefLT" required>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="coefCT" formControlName="coefCT" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="coefVF" formControlName="coefVF" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="refLT" formControlName="refLT" required>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="refCT" formControlName="refCT" required>
            </mat-form-field>
          </mat-expansion-panel>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Static V5.2 settings
              </mat-panel-title>

            </mat-expansion-panel-header>


            <div>
              <table class="mathsStaticSelector table-striped">
                <tr>

                  <th>ID location déformation</th>
                  <th>=</th>
                  <th>ID location Température</th>
                </tr>
                <tr *ngFor="let Y of mathsNaive.paramStaticV5.sensor_Y ; index as i">
                  <td>
                    {{mathsNaive.paramStaticV5.sensor_Y[i]}}
                  </td>
                  <td>=</td>
                  <td>
                    <mat-select [placeholder]="'CHOOSE' | translate"
                                [value]="mathsNaive.paramStaticV5.sensor_X[i]">
                      <mat-option *ngFor="let X of locationsPtForStaticParamsV5" [value]="X"
                                  (click)="setDefEqualsPt(i,X)">
                        {{X}}
                      </mat-option>
                    </mat-select>
                  </td>
                </tr>
              </table>
            </div>


          </mat-expansion-panel>
          <br/>

          <div>
            <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">Back
            </button>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next</button>
          </div>
        </form>
      </mat-step>

      <mat-step [stepControl]="mathsNaiveDynamicForm">
        <form [formGroup]="mathsNaiveDynamicForm" *ngIf="mathsNaiveDynamicForm">
          <ng-template matStepLabel>{{'DYN_SETTINGS'|translate}}</ng-template>
          <mat-slide-toggle formControlName="doDynamic" [(ngModel)]="mathsNaiveDynamicForm.value.doDynamic">
            {{mathsNaiveDynamicForm.value.doDynamic ? 'Dynamic enabled' : 'Dynamic disabled'}}
          </mat-slide-toggle>

          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                Static V5.2 settings
              </mat-panel-title>

            </mat-expansion-panel-header>


            <mat-slide-toggle formControlName="split_tg" [(ngModel)]="mathsNaiveDynamicForm.value.split_tg">
              {{mathsNaiveDynamicForm.value.split_tg ? 'split_tg enabled' : 'split_tg disabled'}}
            </mat-slide-toggle>

            <mat-slide-toggle formControlName="split_tr" [(ngModel)]="mathsNaiveDynamicForm.value.split_tr">
              {{mathsNaiveDynamicForm.value.split_tr ? 'split_tr enabled' : 'split_tr disabled'}}
            </mat-slide-toggle>
            <mat-divider></mat-divider>

            <mat-form-field>
              <input matInput placeholder="sampleInt" formControlName="sampleInt" required>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="split_ts_val" formControlName="split_ts_val" required>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="split_tr_val" formControlName="split_tr_val" required>
            </mat-form-field>


            <mat-form-field>
              <input matInput placeholder="split_tr_sign" formControlName="split_tr_sign" required>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="split_tr_pretrig" formControlName="split_tr_pretrig" required>
            </mat-form-field>

            <mat-form-field>
              <input matInput placeholder="split_tr_postrig" formControlName="split_tr_postrig" required>
            </mat-form-field>

          </mat-expansion-panel>
          <br/>
          <div>
            <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">Back
            </button>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">Next</button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{'CHECK_SAVE'|translate}}</ng-template>

        <div><b [innerHtml]="'SUBSCRIPTION_DATES'|translate">Subscription dates</b></div>


        <mat-form-field class="readonly">
          <input matInput [matDatepicker]="picker1"
                 placeholder="Start subscription date" [value]="mathsNaiveForm.value.dateStart"
                 [readonly]="true">
          <mat-datepicker-toggle matSuffix [for]="picker1" [disabled]="true"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <mat-form-field class="readonly">
          <input matInput [matDatepicker]="picker2"
                 placeholder="End subscription date" [value]="mathsNaiveForm.value.dateEnd" [readonly]="true">
          <mat-datepicker-toggle matSuffix [for]="picker2" [disabled]="true"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>


        <div><b [innerHtml]="'STATIC_SETTINGS'|translate">Static settings</b></div>
        <mat-slide-toggle [(ngModel)]="mathsNaiveStaticForm.value.doStatic" [disabled]="true">
          {{mathsNaiveStaticForm.value.doStatic
          ? 'Static enabled' : 'Static disabled'}}
        </mat-slide-toggle>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Statics settings (eacth v1.0)
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-form-field class="readonly">
            <input matInput placeholder="windowSize (hours)"
                   [value]="mathsNaiveStaticForm.value.window_Size"
                   [readonly]="true" required>
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput placeholder="noteMAX" [value]="mathsNaiveStaticForm.value.noteMAX"
                   [readonly]="true" required>
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput placeholder="coefLT" [value]="mathsNaiveStaticForm.value.coefLT"
                   [readonly]="true" required>
          </mat-form-field>

          <mat-form-field class="readonly">
            <input matInput placeholder="coefCT" [value]="mathsNaiveStaticForm.value.coefCT"
                   [readonly]="true" required>
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput placeholder="coefVF" [value]="mathsNaiveStaticForm.value.coefVF"
                   [readonly]="true" required>
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput placeholder="refLT" [value]="mathsNaiveStaticForm.value.refLT" [readonly]="true"
                   required>
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput placeholder="refCT" [value]="mathsNaiveStaticForm.value.refCT" [readonly]="true"
                   required>
          </mat-form-field>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Static V5.2 settings
            </mat-panel-title>

          </mat-expansion-panel-header>
          <div>
            <table class="mathsStaticSelector table-striped">
              <tr>

                <th>ID location déformation</th>
                <th>=</th>
                <th>ID location Température</th>
              </tr>
              <tr *ngFor="let Y of mathsNaive.paramStaticV5.sensor_Y ; index as i">
                <td>
                  {{mathsNaive.paramStaticV5.sensor_Y[i]}}
                </td>
                <td>=</td>
                <td>
                  <mat-select [placeholder]="'CHOOSE' | translate"
                              [value]="mathsNaive.paramStaticV5.sensor_X[i]" [disabled]="true">
                    <mat-option *ngFor="let X of locationsPtForStaticParamsV5" [value]="X">
                      {{X}}
                    </mat-option>
                  </mat-select>
                </td>
              </tr>
            </table>
          </div>
        </mat-expansion-panel>

        <br/>
        <div><b [innerHtml]="'DYN_SETTINGS'|translate">Dynamic settings</b></div>
        <mat-slide-toggle [disabled]="true" [(ngModel)]="mathsNaiveDynamicForm.value.doDynamic">
          {{mathsNaiveDynamicForm.value.doDynamic ? 'Dynamic enabled' : 'Dynamic disabled'}}
        </mat-slide-toggle>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Static V5.2 settings
            </mat-panel-title>

          </mat-expansion-panel-header>

          <mat-slide-toggle [disabled]="true" [(ngModel)]="mathsNaiveDynamicForm.value.split_tg">
            {{mathsNaiveDynamicForm.value.split_tg ? 'split_tg enabled' : 'split_tg disabled'}}
          </mat-slide-toggle>

          <mat-slide-toggle [disabled]="true" [(ngModel)]="mathsNaiveDynamicForm.value.split_tr">
            {{mathsNaiveDynamicForm.value.split_tr ? 'split_tr enabled' : 'split_tr disabled'}}
          </mat-slide-toggle>
          <mat-divider></mat-divider>

          <mat-form-field class="readonly">
            <input matInput placeholder="sampleInt" [value]="mathsNaiveDynamicForm.value.sampleInt"
                   [readonly]="true" required>
          </mat-form-field>

          <mat-form-field class="readonly">
            <input matInput placeholder="split_ts_val" [value]="mathsNaiveDynamicForm.value.split_ts_val"
                   [readonly]="true" required>
          </mat-form-field>

          <mat-form-field class="readonly">
            <input matInput placeholder="split_tr_val" [value]="mathsNaiveDynamicForm.value.split_tr_val"
                   [readonly]="true" required>
          </mat-form-field>


          <mat-form-field class="readonly">
            <input matInput placeholder="split_tr_sign" [value]="mathsNaiveDynamicForm.value.split_tr_sign"
                   [readonly]="true" required>
          </mat-form-field>

          <mat-form-field class="readonly">
            <input matInput placeholder="split_tr_pretrig"
                   [value]="mathsNaiveDynamicForm.value.split_tr_pretrig"
                   [readonly]="true" required>
          </mat-form-field>

          <mat-form-field class="readonly">
            <input matInput placeholder="split_tr_postrig"
                   [value]="mathsNaiveDynamicForm.value.split_tr_postrig"
                   [readonly]="true" required>
          </mat-form-field>

        </mat-expansion-panel>

        <br/>


        <div>
          <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">Back
          </button>
          <button type="button" class="btn btn-warning" (click)="persistMaths()">
            <app-progressbar *ngIf="showSpinner===true"></app-progressbar>
            {{'SAVE'|translate}}</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>


    <div *ngIf="readOnly">

      <div><b [innerHtml]="'SUBSCRIPTION_DATES'|translate">Subscription dates</b></div>


      <mat-form-field class="readonly">
        <input matInput [matDatepicker]="picker1"
               placeholder="Start subscription date" [value]="mathsNaiveForm.value.dateStart"
               [readonly]="true">
        <mat-datepicker-toggle matSuffix [for]="picker1" [disabled]="true"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="readonly">
        <input matInput [matDatepicker]="picker2"
               placeholder="End subscription date" [value]="mathsNaiveForm.value.dateEnd" [readonly]="true">
        <mat-datepicker-toggle matSuffix [for]="picker2" [disabled]="true"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>


      <div><b [innerHtml]="'STATIC_SETTINGS'|translate">Static settings</b></div>
      <mat-slide-toggle [(ngModel)]="mathsNaiveStaticForm.value.doStatic" [disabled]="true">
        {{mathsNaiveStaticForm.value.doStatic
        ? 'Static enabled' : 'Static disabled'}}
      </mat-slide-toggle>

      <mat-expansion-panel [expanded]="mathsNaiveStaticForm.value.doStatic">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Statics settings (eacth v1.0)
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-form-field class="readonly">
          <input matInput placeholder="windowSize (hours)"
                 [value]="mathsNaiveStaticForm.value.window_Size"
                 [readonly]="true" required>
        </mat-form-field>
        <mat-form-field class="readonly">
          <input matInput placeholder="noteMAX" [value]="mathsNaiveStaticForm.value.noteMAX"
                 [readonly]="true" required>
        </mat-form-field>
        <mat-form-field class="readonly">
          <input matInput placeholder="coefLT" [value]="mathsNaiveStaticForm.value.coefLT"
                 [readonly]="true" required>
        </mat-form-field>

        <mat-form-field class="readonly">
          <input matInput placeholder="coefCT" [value]="mathsNaiveStaticForm.value.coefCT"
                 [readonly]="true" required>
        </mat-form-field>
        <mat-form-field class="readonly">
          <input matInput placeholder="coefVF" [value]="mathsNaiveStaticForm.value.coefVF"
                 [readonly]="true" required>
        </mat-form-field>
        <mat-form-field class="readonly">
          <input matInput placeholder="refLT" [value]="mathsNaiveStaticForm.value.refLT" [readonly]="true"
                 required>
        </mat-form-field>
        <mat-form-field class="readonly">
          <input matInput placeholder="refCT" [value]="mathsNaiveStaticForm.value.refCT" [readonly]="true"
                 required>
        </mat-form-field>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="mathsNaiveStaticForm.value.doStatic">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Static V5.2 settings
          </mat-panel-title>

        </mat-expansion-panel-header>
        <div>
          <table class="mathsStaticSelector table-striped">
            <tr>

              <th>ID location déformation</th>
              <th>=</th>
              <th>ID location Température</th>
            </tr>
            <tr *ngFor="let Y of mathsNaive.paramStaticV5.sensor_Y ; index as i">
              <td>
                {{mathsNaive.paramStaticV5.sensor_Y[i]}}
              </td>
              <td>=</td>
              <td>
                <mat-select [placeholder]="'CHOOSE' | translate"
                            [value]="mathsNaive.paramStaticV5.sensor_X[i]" [disabled]="true">
                  <mat-option *ngFor="let X of locationsPtForStaticParamsV5" [value]="X">
                    {{X}}
                  </mat-option>
                </mat-select>
              </td>
            </tr>
          </table>
        </div>
      </mat-expansion-panel>

      <br/>
      <div><b [innerHtml]="'DYN_SETTINGS'|translate">Dynamic settings</b></div>
      <mat-slide-toggle [disabled]="true" [(ngModel)]="mathsNaiveDynamicForm.value.doDynamic">
        {{mathsNaiveDynamicForm.value.doDynamic ? 'Dynamic enabled' : 'Dynamic disabled'}}
      </mat-slide-toggle>

      <mat-expansion-panel [expanded]="mathsNaiveDynamicForm.value.doDynamic">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Static V5.2 settings
          </mat-panel-title>

        </mat-expansion-panel-header>

        <mat-slide-toggle [disabled]="true" [(ngModel)]="mathsNaiveDynamicForm.value.split_tg">
          {{mathsNaiveDynamicForm.value.split_tg ? 'split_tg enabled' : 'split_tg disabled'}}
        </mat-slide-toggle>

        <mat-slide-toggle [disabled]="true" [(ngModel)]="mathsNaiveDynamicForm.value.split_tr">
          {{mathsNaiveDynamicForm.value.split_tr ? 'split_tr enabled' : 'split_tr disabled'}}
        </mat-slide-toggle>
        <mat-divider></mat-divider>

        <mat-form-field class="readonly">
          <input matInput placeholder="sampleInt" [value]="mathsNaiveDynamicForm.value.sampleInt"
                 [readonly]="true" required>
        </mat-form-field>

        <mat-form-field class="readonly">
          <input matInput placeholder="split_ts_val" [value]="mathsNaiveDynamicForm.value.split_ts_val"
                 [readonly]="true" required>
        </mat-form-field>

        <mat-form-field class="readonly">
          <input matInput placeholder="split_tr_val" [value]="mathsNaiveDynamicForm.value.split_tr_val"
                 [readonly]="true" required>
        </mat-form-field>


        <mat-form-field class="readonly">
          <input matInput placeholder="split_tr_sign" [value]="mathsNaiveDynamicForm.value.split_tr_sign"
                 [readonly]="true" required>
        </mat-form-field>

        <mat-form-field class="readonly">
          <input matInput placeholder="split_tr_pretrig"
                 [value]="mathsNaiveDynamicForm.value.split_tr_pretrig"
                 [readonly]="true" required>
        </mat-form-field>

        <mat-form-field class="readonly">
          <input matInput placeholder="split_tr_postrig"
                 [value]="mathsNaiveDynamicForm.value.split_tr_postrig"
                 [readonly]="true" required>
        </mat-form-field>

      </mat-expansion-panel>
    </div>

  </div>


  <div class="modal-footer">

    <button type="button" class="btn btn-light" (click)="closeModal()" [innerHTML]="'CLOSE' | translate">Close</button>
  </div>
</ng-template>


<button *ngIf="mode ==='create' && projectState ===0" type="button" class="btn list-tools" (click)="openModal(content)"
        placement="left"
        [ngbTooltip]="'CREATE_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faPlus"></fa-icon>
</button>
<button *ngIf="mode ==='read' && projectState !==0" type="button" class="btn list-tools" (click)="openModal(content)"
        placement="left"
        [ngbTooltip]="'READ_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faEye"></fa-icon>
</button>
<button *ngIf="mode ==='update' && projectState !==0" type="button" class="btn list-tools" (click)="openModal(content)"
        placement="left"
        [ngbTooltip]="'UPDATE_ICON_TOOLTIP' | translate">
  <fa-icon [icon]="faEdit"></fa-icon>
</button>
<button *ngIf="mode ==='delete' && projectState !==0" type="button" class="btn list-tools" style="background: red"
        (click)="revokeMaths(content)"
        placement="left"
        [ngbTooltip]="'DELETE_ICON_TOOLTIP' | translate">
  <app-progressbar *ngIf="showSpinnerDelete===true"></app-progressbar>
  <fa-icon [pulse]="showSpinnerDelete" [icon]="faTrashAlt"></fa-icon>
</button>
